import React from 'react';
import { ActionIcon, Text, useMantineTheme } from '@mantine/core';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';
import { PreviewContainer } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/MasterDocuments/styles.ts';

interface Props {
	fileName: string;
	onRemove: () => void;
}

export const FileUploadPreview = ({ fileName, onRemove }: Props) => {
	const theme = useMantineTheme();

	return (
		<PreviewContainer $borderColor={theme.colors.gray[4]}>
			<Text size="sm" fw={500}>
				{fileName}
			</Text>
			<ActionIcon variant="subtle" onClick={onRemove} aria-label="Remove file">
				<Icon variant="trash-can" size="lg" color="black" />
			</ActionIcon>
		</PreviewContainer>
	);
};
